/**
 * @generated SignedSource<<b9f8d3b4438328a0b372a0a3d83ea182>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type textWithPagesElementForm_TextWithPagesElementFragment$data = {
  readonly id: string;
  readonly task: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"textWithPagesElementPagesEditor_PagesFragment">;
  readonly " $fragmentType": "textWithPagesElementForm_TextWithPagesElementFragment";
};
export type textWithPagesElementForm_TextWithPagesElementFragment$key = {
  readonly " $data"?: textWithPagesElementForm_TextWithPagesElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"textWithPagesElementForm_TextWithPagesElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "textWithPagesElementForm_TextWithPagesElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "task",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "textWithPagesElementPagesEditor_PagesFragment"
    }
  ],
  "type": "TextWithPagesElement",
  "abstractKey": null
};

(node as any).hash = "94c01e1b04b3437f64c1df35917d08fd";

export default node;
